/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     用户数据管理
  +--------------------------------------------------------------------------------------
*/

import Vue from 'vue'
import { object2Array } from '@/utils/common'

import { loginByUsernameApi, logoutApi, superFastLogin, loginConfirmApi } from '@/api/common/loginApi'
import { getUserInfoApi, postUserInfoApi } from '@/api/fam/famUserApi'
import { getGodSettingApi } from '@/api/fam/famGodApi'
import { dataStatApi } from '@/api/rms/rmsDownloadApi'
import { getAccessToken, setAccessToken, removeAccessToken } from '@/utils/cookie'
/**
 * logoutClean: 退出程序时清理工作
 */
function logoutClean(commit) {
  commit('SET_PERMISSIONS', [])
  removeAccessToken()
}

const userStore = {
  state: {
    accessToken: getAccessToken(),
    taskInProcess: 0,
    taskToDownload: 0,
    superFastLogin: false,
    partnerLevelArr: []
  },

  mutations: {
    SET_ACCESS_TOKEN: (state, accessToken) => {
      state.accessToken = accessToken
    },

    SET_USER: (state, user) => {
      Object.keys(user).forEach((item) => {
        Vue.set(state, item, user[item])
      })
    },

    SET_TASK_STAT: (state, obj) => {
      state.taskInProcess = obj.in_process || 0
      state.taskToDownload = obj.to_download || 0
    },
    
    SET_SUPER_FAST_LOGIN: (state, superFastLogin) => {
      state.superFastLogin = superFastLogin
    },

    SET_PARTNER_LEVEL_ARR: (state, partnerLevelArr) => {
      state.partnerLevelArr = partnerLevelArr
    },

  },
  actions: {
    // 用户名登录
    loginByUsernameAction({ commit }, formData) {
      return new Promise((resolve, reject) => {
        loginConfirmApi(formData).then(res => {
          if (!res.errno) {
            commit('SET_ACCESS_TOKEN', res.data.access_token)
            setAccessToken(res.data.access_token)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    loginByQuickAction({ commit }, formData){
      return new Promise((resolve, reject) => {
        superFastLogin(formData).then(res => {
          if (!res.errno) {
            commit('SET_ACCESS_TOKEN', res.data.access_token)
            setAccessToken(res.data.access_token)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    // 获取用户信息(含客户信息)
    getUserInfoAction({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfoApi().then(res => {
          if (!res.errno) {
            commit('SET_USER', res.data.profile)
            resolve(res)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },

    getCustomizationInfoAction({ commit, state }) {
      return new Promise((resolve, reject) => {
        getGodSettingApi().then(res => {
          if (!res.errno) {
            commit('SET_GOD', res.data)
            commit('SET_PARTNER_LEVEL_ARR', res.data.customer_level_config)
            resolve(res)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },

    // 设置用户信息
    setUserInfoAction({ commit, state }, formData) {
      return new Promise((resolve, reject) => {
        postUserInfoApi(formData).then(res => {
          if (!res.errno) {
            commit('SET_USER', res.data)
          }
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },

    // 登出
    logOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logoutApi().then((res) => {
          logoutClean(commit)
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },

    // 前端登出
    fedLogOut({ commit }) {
      return new Promise(resolve => {
        logoutClean(commit)
        resolve()
      })
    },

    // 获取下载任务统计
    getExportTaskStatAction({ commit, state }) {
      return new Promise((resolve, reject) => {
        dataStatApi().then(res => {
          if (!res.errno) {
            commit('SET_TASK_STAT', res.data)
            resolve(res)
          } else {
            reject(res)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
  }
}

export default userStore
